import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useApp } from '../../context/AppContext'
import './Layout.css'

export default function Layout({ children }) {
  const { signOut, profile } = useApp()
  const location = useLocation()

  const navItems = [
    { path: '/dashboard', label: 'Acasa', icon: '🏠' },
    { path: '/slot', label: 'Simulator', icon: '🎰' },
    { path: '/calendar', label: 'Calendar', icon: '📅' },
    { path: '/jurnal', label: 'Jurnal', icon: '📓' },
    { path: '/educatie', label: 'Educatie', icon: '💡' },
  ]

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <span className="logo-text">STOP <span>PACANELE</span></span>
        </div>

        {profile && (
          <div className="sidebar-level">
            <span className={`level-badge level-${profile.gravitate?.nivel}`}>
              {profile.gravitate?.nivel}
            </span>
          </div>
        )}

        <nav className="sidebar-nav">
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <Link to="/profil" className="nav-item">
            <span className="nav-icon">⚙️</span>
            <span className="nav-label">Profil</span>
          </Link>
          <button className="nav-item nav-signout" onClick={signOut}>
            <span className="nav-icon">🚪</span>
            <span className="nav-label">Iesire</span>
          </button>
        </div>
      </aside>

      <main className="main-content">
        {children}
      </main>
    </div>
  )
}
